import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function PainSection() {
  return <section id="dolor" className="py-24 md:py-32 bg-neutral-900 border-y border-neutral-800 relative overflow-hidden" data-id="element-262">
      {/* Subtle decorative lines */}
      <div className="absolute top-0 left-12 w-[1px] h-full bg-neutral-800/50 hidden md:block" data-id="element-263" />
      <div className="absolute top-0 right-12 w-[1px] h-full bg-neutral-800/50 hidden md:block" data-id="element-264" />

      <div className="max-w-4xl mx-auto px-6 md:px-12 relative z-10" data-id="element-265">
        <FadeIn data-id="element-266">
          <div className="w-12 h-[2px] bg-red-600 mb-8" data-id="element-267" />
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white tracking-tight mb-8 leading-tight text-balance" data-id="element-268">
            Si ya probaste señales, estrategias e indicadores… y seguís
            perdiendo,{' '}
            <span className="text-red-500" data-id="element-269">no es falta de disciplina.</span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-270">
          <div className="prose prose-invert prose-lg max-w-none text-neutral-400" data-id="element-271">
            <p className="mb-6" data-id="element-272">
              La mayoría no falla por "no esforzarse". Falla por operar sin un
              mapa claro, sin confirmaciones y con decisiones emocionales.
            </p>
            <p className="text-white font-medium border-l-2 border-red-600 pl-6 py-2 bg-neutral-950/30" data-id="element-273">
              Protocolo Sniper existe para darte un sistema simple, repetible y
              entrenable.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}